var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeatherClouds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36.00003 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-227.99997 -22)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 37,
    r: 10,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    transform: "translate(-227.99997 -22)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 177,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    transform: "translate(-227.99997 -22)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 30.00005,
    width: 31.92524,
    height: 12.85966,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    transform: "translate(-227.99997 -22)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 38,
    width: 10,
    height: 5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    transform: "translate(-227.99997 -22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.92387,40.924a1.96213,1.96213,0,1,1-1.96195-1.93567,1.94911,1.94911,0,0,1,1.96195,1.93567",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    transform: "translate(-227.99997 -22)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 30,
    width: 26,
    height: 13,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    transform: "translate(-227.99997 -22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.27734,40.924a1.96213,1.96213,0,1,1-1.96195-1.93567,1.94911,1.94911,0,0,1,1.96195,1.93567",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    transform: "translate(-227.99997 -22)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 234.96195,
    y: 38.98836,
    width: 5.52202,
    height: 3.87135,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l",
    transform: "translate(-227.99997 -22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.07317,41.64655A2.95815,2.95815,0,0,0,259,38.658a2.99083,2.99083,0,0,0-1.86357-2.78422,2.49851,2.49851,0,0,0,.0343-.39107,2.40351,2.40351,0,0,0-2.378-2.42816,2.3231,2.3231,0,0,0-1.05183.251,3.99892,3.99892,0,0,0-7.46,1.144,3.74866,3.74866,0,0,0,1.37767,7.19693Z",
    style: {
      fill: "none"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weather_clouds") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.00003,
    width: 30,
    height: 30,
    style: {
      fill: "#fed307"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#c)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#e)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#f)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#g)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    y: 11.98828,
    width: 13.9239,
    height: 13.87135,
    style: {
      fill: "#989798"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#h)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#g)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.35347,
    y: 11.98828,
    width: 13.9239,
    height: 13.87135,
    style: {
      fill: "#989798"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#j)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#g)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.96198,
    y: 11.98836,
    width: 15.52202,
    height: 13.87135,
    style: {
      fill: "#989798"
    }
  }))))))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#l)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.00003,
    y: 4.18678,
    width: 25,
    height: 20.45978,
    style: {
      fill: "#989798",
      opacity: 0.980000019073486
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherClouds);
export default __webpack_public_path__ + "static/media/weather_clouds.0590cf0c26ec83ef5b074bf36dfc0c3e.svg";
export { ForwardRef as ReactComponent };